import getHourStringFromNumber from "utils/helpers/getHourStringFromNumber/getHourStringFromNumber";

export default getHourStringFromNumber;
